import { render } from "./edit-goods.vue?vue&type=template&id=3acc682d&scoped=true&ts=true"
import script from "./edit-goods.vue?vue&type=script&lang=ts"
export * from "./edit-goods.vue?vue&type=script&lang=ts"

import "./edit-goods.vue?vue&type=style&index=0&id=3acc682d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acc682d"]])

export default __exports__